module.exports = __webpack_public_path__ + "img/NewsCenterDetails5_pic1.76fc0325.png";